import script from "./ProblemSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ProblemSection.vue?vue&type=script&setup=true&lang=js"

import "./ProblemSection.vue?vue&type=style&index=0&id=40319675&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40319675"]])

export default __exports__